const breakpoints = {
  bp1: '(max-width: 460px)',
  bp2: '(min-width: 461px) and (max-width: 1024px)',
  bp3: '(min-width: 1025px) and (max-width: 1200px)',
  bp4: '(min-width: 1201px) and (max-width: 1600px)',
  bp5: '(min-width: 1601px)',
}

export { breakpoints }
